module.exports = __webpack_public_path__ + "img/ep-0.718feb40.jpg";